import Form from '@arivaa-react/components/form';

export function EditHeaderTopBar() {
  const handleSubmit = async (values) => {
    console.log(values);
  };
  return (
    <div className="card navigation">
      <div className="heading">
        <p className="label">Edit Topbar</p>
      </div>
      <div className="edit-form">
        <Form
          renderForm={({ renderElement }) => {
            return (
              <div>
                <div className="item">
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Opening Hours',
                    required: true,
                    options: {
                      initialValue: '',
                    },
                  })}
                </div>
                <div className="item">
                  {renderElement({
                    type: 'text',
                    name: 'title',
                    label: 'Call',
                    required: true,
                    options: {
                      initialValue: '',
                    },
                  })}
                </div>
                <div className="item">
                  {renderElement({
                    type: 'select',
                    name: 'type',
                    label: 'Show Topbar',
                    required: true,
                    data: ['Yes', 'No'],
                    options: {
                      initialValue: 'Yes',
                    },
                  })}
                </div>
              </div>
            );
          }}
          onSubmit={handleSubmit}
          submitButtonProps={{
            children: 'Save',
          }}
        />
      </div>
    </div>
  );
}
